import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TemplateCard from "@Broker/@Modules/marketing/templates/components/template-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CampaignDesignSection",
  components: {
    TemplateCard
  },
  props: {
    label: {
      type: Boolean,
      default: true
    },
    templateData: {
      type: Object,
      default: () => ({})
    },
    selectTemplateParams: {
      type: Object,
      default: () => ({})
    },
    save: {
      type: Boolean,
      default: true
    },
    editTemplate: {
      type: Boolean,
      default: true
    },
    deleteTemplate: {
      type: Boolean,
      default: false
    },
    templateActions: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goSelectTemplate() {
      this.$router.replace({
        path: "/marketing/templates",
        query: _objectSpread({
          selectPage: true
        }, this.selectTemplateParams.query)
      });
    }
  }
});